import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PlanCard } from "@/pages/Billing";
import { BillingToggle, planKey } from "@/components/BillingToggle";

export const SignupPlans = ({ plans, onReady }) => {
  const [busy, setBusy] = useState(false);
  const [codes, setCodes] = useState({ monthly: "", pro: "" });
  const [interval, setBillingInterval] = useState(sessionStorage.getItem("dt_interval") || "year");
  const go = async (id) => {
    setBusy(true);
    const plan = planKey(id, interval);
    try {
      const code = codes[id].trim();
      const { data } = await api.post("/billing/signup/checkout", { plan, origin_url: window.location.origin, code: code || null });
      if (data.ready) { toast.success("Code applied. Let's set up your church."); onReady(); setBusy(false); return; }
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not start checkout");
      setBusy(false);
    }
  };
  return (
    <div className="fade-up" data-testid="signup-plans">
      <p className="eyebrow">Step 1 of 2</p>
      <h1 className="font-display text-navy text-4xl font-semibold tracking-tight mt-3">Choose your <span className="font-accent text-teal">church plan.</span></h1>
      <p className="text-muted-ink mt-4 max-w-2xl">After checkout you'll name your church, and your assessment link and ministry teams will be ready to go. Have a discount code? Enter it on a plan before you continue.</p>
      <div className="mt-8 max-w-4xl flex justify-center"><BillingToggle interval={interval} onChange={setBillingInterval} /></div>
      <div className="grid md:grid-cols-2 gap-6 mt-6 max-w-4xl">
        {["monthly", "pro"].map((id) => (
          <PlanCard key={id} id={id} plan={plans[planKey(id, interval)]} highlight={id === "pro"} busy={busy} stripeOnly
            onStripe={() => go(id)} code={codes[id]} setCode={(v) => setCodes((p) => ({ ...p, [id]: v }))} />
        ))}
      </div>
    </div>
  );
};
